/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateWithdrawalHistory } from '../models/CreateWithdrawalHistory';
import type { PaginatedWithdrawalHistoryListDto } from '../models/PaginatedWithdrawalHistoryListDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WithdrawalHistoriesService {
  /**
   * 내 출금 요청 내역 조회
   * @returns PaginatedWithdrawalHistoryListDto
   * @throws ApiError
   */
  public static withdrawalHistoryControllerFindWithdrawalHistoriesByUser({
    page = 1,
    itemsPerPage = 30,
  }: {
    page?: number;
    itemsPerPage?: number;
  }): CancelablePromise<PaginatedWithdrawalHistoryListDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/me/withdrawal-histories',
      query: {
        page: page,
        itemsPerPage: itemsPerPage,
      },
    });
  }

  /**
   * 출금 요청
   * @returns any
   * @throws ApiError
   */
  public static withdrawalHistoryControllerCreateWithdrawalHistory({
    requestBody,
  }: {
    requestBody: CreateWithdrawalHistory;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/withdrawal-histories',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
